import React, { useState } from "react";
import { getCurrentUser } from "./api";
import Login from "./components/Login";
import ShellV3 from "./components/ShellV3";
import ShellV4 from "./components/ShellV4";
import { ToastProvider } from "./components/Toast";
import { ThemeProvider } from "./components/Theme";
import { VersionProvider, useVersion } from "./components/Version";
import BrowserSupportBanner from "./components/BrowserSupportBanner";

// One unified shell now — the old League and Umpire workspaces have
// been merged into Gabruz Universe. League views live under the
// League sidebar section (committee-role-gated); Officiating (umpire
// polls) is reached via a Home dashboard tile for UMPIRE users. See
// nav.js DESKTOP_SECTIONS and Module.jsx routes.
function AppInner({ user, setUser }) {
  const { version } = useVersion();
  if (!user) return <Login onLogin={setUser} />;
  if (version === "v4") return <ShellV4 user={user} setUser={setUser} />;
  return <ShellV3 user={user} setUser={setUser} />;
}

export default function App() {
  const [user, setUser] = useState(getCurrentUser());
  return (
    <VersionProvider>
      <ThemeProvider>
        <ToastProvider>
          <BrowserSupportBanner />
          <AppInner user={user} setUser={setUser} />
        </ToastProvider>
      </ThemeProvider>
    </VersionProvider>
  );
}
